import React from 'react';

function PackagingPurchaseOrderItemsCardShell({ children }) {
    return (
        <div className="rounded-md border bg-card p-6 shadow-sm">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-1">
                    <h2 className="text-left text-lg font-semibold tracking-tight text-foreground">
                        Packaging Purchase Order Items
                    </h2>
                </div>
                {children}
            </div>
        </div>
    );
}

export function PackagingPurchaseOrderItemsCard({ isEditing = false }) {
    const placeholderText = isEditing ? 'Not yet implemented (edit mode)' : 'Not yet implemented (view mode)';

    return (
        <PackagingPurchaseOrderItemsCardShell>
            <div className="text-sm text-muted-foreground">{placeholderText}</div>
        </PackagingPurchaseOrderItemsCardShell>
    );
}

PackagingPurchaseOrderItemsCard.displayName = 'PackagingPurchaseOrderItemsCard';
